import React, { ChangeEvent } from 'react';
import * as Queries from '@api/graphql/queries';
import { Query, QueryResult } from 'react-apollo';
import { adminBannerPlaces, adminBannerPlaces_adminBannerPlaces } from '@api/graphql/types';

interface Prop {
    name: string;
    value: string[];
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: any, name: string) => void;
}

class BannerPlaceSelector extends React.Component<Prop> {
    private onSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        const values = [].filter.call(e.currentTarget.options, (o: any) => o.selected).map((o: any) => o.value);
        this.props.onChangeHandler(values, this.props.name);
    }

    private renderSelect(result: QueryResult<adminBannerPlaces>) {
        if (result.loading) return null;
        if (result.error) return `Error!: ${result.error}`;

        if (result.data) {
            return (
                <>
                    <select name={name} className="form-control" onChange={this.onSelect} value={this.props.value[0] || undefined}>
                        <option value="">---</option>
                        {result.data.adminBannerPlaces.sort((a: adminBannerPlaces_adminBannerPlaces, b: adminBannerPlaces_adminBannerPlaces) => (parseInt(a.id, 10) - parseInt(b.id, 10))).map((bannerPlace: adminBannerPlaces_adminBannerPlaces) => (
                            <option value={bannerPlace.id} key={bannerPlace.id}>{bannerPlace.name} ({bannerPlace.type_id})</option>
                        ))}
                    </select>
                    {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
                </>
            );

        }
        return null;
    }

    public render() {
        return (
            <Query query={Queries.adminBannerPlaces}>
                {queryResult => this.renderSelect(queryResult)}
            </Query>
        );
    }
}

export default BannerPlaceSelector;



// WEBPACK FOOTER //
// ./src/components/Form/BannerPlaceSelect.tsx